import React, { useEffect, useState } from 'react';
import { useParams, useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { Spinner, Alert, Button } from 'react-bootstrap';

const VerifyEmail = () => {
 const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('verifying');
  const [message, setMessage] = useState('Verifying your email...');

  useEffect(() => {
    const verifyEmail = async () => {
      const token = searchParams.get('token'); // Get token from query params
      
      if (!token) {
        setStatus('error');
        setMessage('Missing verification token');
        return;
      }

      try {
        const response = await axios.post(
          `${process.env.REACT_APP_BASE_URL}/user/verify-email`, 
          { token } // Send token in request body
        );
        
        if (response.data.success) {
          setStatus('success');
          setMessage('Email verified successfully');
        } else {
          setStatus('error');
          setMessage(response.data.message || 'Verification failed');
        }
      } catch (error) {
        setStatus('error');
        setMessage(error.response?.data?.message || 'Verification failed. The link may be expired or invalid.');
      }
    };

    verifyEmail();
  }, [searchParams]);

  return (
    <div className="container mt-5">
      <div className="row justify-content-center">
        <div className="col-md-6 text-center">
          {status === 'verifying' && (
            <>
              <Spinner animation="border" role="status" />
              <p className="mt-3">{message}</p>
            </>
          )}
          
          {status === 'success' && (
            <>
              <Alert variant="success">
                <Alert.Heading>Verification Successful!</Alert.Heading>
                <p>{message}</p>
              </Alert>
              <Button 
                variant="primary" 
                onClick={() => navigate('/login')}
              >
                Go to Login
              </Button>
            </>
          )}
          
          {status === 'error' && (
            <Alert variant="danger">
              <Alert.Heading>Verification Failed</Alert.Heading>
              <p>{message}</p>
              <p>Please contact support if you need assistance.</p>
            </Alert>
          )}
        </div>
      </div>
    </div>
  );
};

export default VerifyEmail;